import { apps } from "../index-client.mjs";
const thirdpartyTracking = apps.thirdpartyTracking;
const trackAdjust = thirdpartyTracking.trackAdjust;
export {
  thirdpartyTracking,
  trackAdjust
};
/*                                     */
